import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { SUPABASE_READY, supabase } from '../lib/supabaseClient';
import './Register.css';

function ResetPassword() {
  const navigate = useNavigate();
  const [password, setPassword] = useState('');
  const [confirm, setConfirm] = useState('');
  const [msg, setMsg] = useState('');
  const [ready, setReady] = useState(false);

  // Supabase fires PASSWORD_RECOVERY when the reset link is opened
  useEffect(() => {
    if (!SUPABASE_READY) return;

    const { data: { subscription } } = supabase.auth.onAuthStateChange((event) => {
      if (event === 'PASSWORD_RECOVERY') {
        setReady(true);
      }
    });

    return () => subscription.unsubscribe();
  }, []);

  const onSubmit = async (e) => {
    e.preventDefault();
    setMsg('');

    if (password !== confirm) {
      setMsg('Passwords do not match.');
      return;
    }

    const { error } = await supabase.auth.updateUser({ password });
    if (error) {
      setMsg(error.message);
      return;
    }

    setMsg('✅ Password updated! Redirecting you to sign in…');
    setTimeout(() => navigate('/register'), 2500);
  };

  if (!ready) {
    return (
      <div className="page-container">
        <div className="card" style={{ textAlign: 'center', padding: '3rem 1.5rem' }}>
          <p style={{ fontSize: '1.5rem', marginBottom: '1rem' }}>🔗</p>
          <h2 style={{ color: '#0a3d62', marginBottom: '0.5rem' }}>Waiting for reset link…</h2>
          <p style={{ color: '#555' }}>
            Open the link in the email we sent you. If you arrived here by mistake,{' '}
            <a href="/register" style={{ color: '#0a3d62' }}>go back to sign in</a>.
          </p>
        </div>
      </div>
    );
  }

  return (
    <div className="page-container">
      <h1 className="page-title">Set New Password</h1>
      <p className="page-subtitle">Choose a new password for your account.</p>
      <div className="card">
        <form onSubmit={onSubmit} className="register-form">
          <div className="form-group">
            <label htmlFor="newPassword">New Password *</label>
            <input
              id="newPassword"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              minLength="8"
              required
            />
          </div>
          <div className="form-group">
            <label htmlFor="confirmPassword">Confirm Password *</label>
            <input
              id="confirmPassword"
              type="password"
              value={confirm}
              onChange={(e) => setConfirm(e.target.value)}
              minLength="8"
              required
            />
          </div>
          {msg && <p className="form-note">{msg}</p>}
          <button type="submit" className="btn btn-primary">Update Password</button>
        </form>
      </div>
    </div>
  );
}

export default ResetPassword;
